// InfiltrationDialog.js
import { useState, useEffect } from "react"
import { Typography, Button } from '@mui/material'
import InfiltrationForm from './InfiltrationForm'
import { UniversalDropDown } from "@fileops/swmm-react"
import "../../css/DemoCode.css"


/**
 * Frame for data inputs. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {string} targetType The name of the SWMM inp section targetted by this form.
 * @param {string} target The name of the object targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function InfiltrationDialog({ model, setModel, targetType, target }) {
  const [infilMethod, setInfilMethod] = useState(model.INFILTRATION && model.INFILTRATION[target] && model.INFILTRATION[target].InfilMethod?model.INFILTRATION[target].InfilMethod:model.OPTIONS.INFILTRATION)
  const [submodel, setSubmodel] = useState()
  
  // Create a submodel for this editor interface.
  useEffect(()=>{
    let INFILTRATION = {}

    if(model.INFILTRATION && model.INFILTRATION[target] && infilMethod === model.INFILTRATION[target].InfilMethod){
      INFILTRATION = {
        [target]: {
          ...model.INFILTRATION[target]
        }
      }
    } else {
      switch(infilMethod){
        case 'CURVE_NUMBER':
          INFILTRATION = {
            [target]:{
              "Param1": "80",
              "Param2": "0.5",
              "Param3": "7",
              "InfilMethod": model.OPTIONS.INFILTRATION
          }}
          break;
        case 'HORTON': // fall through
        case 'MODIFIED_HORTON':
          INFILTRATION = {
            [target]:{
              "Param1": "3.0",
              "Param2": "0.5",
              "Param3": "4",
              "Param4": "7",
              "Param5": "0",
              "InfilMethod": model.OPTIONS.INFILTRATION
          }}
          break; 
        case 'GREEN_AMPT': // fall through
        case 'MODIFIED_GREEN_AMPT':
          INFILTRATION = {
            [target]:{
              "Param1": "3.5",
              "Param2": "0.5",
              "Param3": "0.25",
              "InfilMethod": model.OPTIONS.INFILTRATION
          }}
          break;
    }}

    setSubmodel({
      INFILTRATION: INFILTRATION
    })
  },[infilMethod])

  const saveEdits = () => {
    let cleanSub = JSON.parse(JSON.stringify(submodel))
    setModel(prev => ({
      ...prev,
      INFILTRATION:{
        ...prev.INFILTRATION, 
        [target]: {
          ...cleanSub.INFILTRATION[target],
          InfilMethod: infilMethod
        }
      }
    }))
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  if(submodel){
    return(
      <>
      {
        <>
          <Typography id="modal-modal-title" variant="p4" >
            <div style={{display:"flex", flexDirection: "column", padding: '10px'}}>
              <label>Infiltration for Subcatchment {target}</label>
            </div>
          </Typography>
          <div>
            <Button fullWidth onClick={saveEdits} >Save Edits</Button>
          </div>
          <div style={{height: "280px", background:'black', overflowY: 'hidden', paddingBottom:"120px"}}>
            <UniversalDropDown 
              IDs={['CURVE_NUMBER', 'HORTON', 'MODIFIED_HORTON', 'GREEN_AMPT', 'MODIFIED_GREEN_AMPT']} 
              selectText={"Select an Infiltration Type"} 
              value={infilMethod}
              onChange={(val)=>setInfilMethod(val)} >
            </UniversalDropDown>
            {
              targetType && 
              targetType in model && 
              target &&
              <InfiltrationForm model={submodel} setModel={setSubmodel} fullModel={model} infilMethod={infilMethod} target={target} />
            }
          </div>
          </>
        }
      </>
    )
  } else {
    return ( 
    <>
    </>)
  }
}